import { HCPFlowEnum } from './hcp-flow.interface'
import { IHCPFlowKanbanCard } from './hcp-flow-card.interface'

const FLOWS_AFTER_ART: ReadonlySet<string> = new Set([
  HCPFlowEnum.SHEET,
  HCPFlowEnum.PRODUCTION,
  HCPFlowEnum.MACHINE_PRODUCTION,
  HCPFlowEnum.LOGISTICS,
])

const AWAITING_ART_APPROVED_SEQUENCE = 8

/** Arte deste item já aprovada (independente de outros itens do pedido). */
export function isItemArtApproved(
  card: IHCPFlowKanbanCard,
  flow?: HCPFlowEnum
): boolean {
  const currentFlow = card.hcpCurrentFlow || flow

  if (currentFlow && FLOWS_AFTER_ART.has(currentFlow)) {
    return true
  }

  if (card.hcpCurrentFlowStatusSequence === AWAITING_ART_APPROVED_SEQUENCE) {
    return true
  }

  if (card.allArtsApproved === true) return true
  if (card.artLink) return true

  return false
}

/** Outros itens do mesmo pedido ainda com arte pendente. */
export function isOrderWithPendingArts(card: IHCPFlowKanbanCard): boolean {
  return card.allArtsApproved === false
}
